var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cell"},on:{"click":_vm.onclickself}},[(_vm.a)?[_vm._v(_vm._s(_vm.text))]:void 0],2)}
var staticRenderFns = []

export { render, staticRenderFns }